<template>
  <div>
    <button @click="open()">open modal</button>
    <swipe-modal
      v-model="modal"
      contents-height="80vh"
      border-top-radius="16px"
      @close="close()"
    >
    </swipe-modal>
  </div>
</template>

<script setup lang="ts">
import swipeModal from '@takuma-ru/vue-swipe-modal';
import { ref } from 'vue';

const modal = ref(false);

const open = () => {
  modal.value = true;
};

const close = () => {};
</script>

<style scoped>

</style>